import * as angular from 'angular';
import { OmcComponent } from 'shared/models/omc.types';
import { OmcFunc } from '../shared/functions/omc.functions';
import { TaskView } from '../shared/models/task-view.model';
import { JobTaskHistory, JobHistoryTaskRecords } from '../shared/models/job-task-execution-history.model';
import { MatDialogService } from '../shared/services/mat-dialog.service';
import * as moment from 'moment';
import { language } from "../shared/language/language.const";
import { JobsDialogData } from "../shared/models/jobsDialogData";

export class ActivityMonitorController implements angular.IController {
    //public enum EventNames {
    //    CpuLoad,
    //    AvailableMemory,
    //    DiskLoad,
    //    TotalMemory
    //}

    jobCheck: any = undefined;
    jobStatusUpdatePeriodSeconds: any = 10;
    enableAutoRefresh: any = true;
    isRefreshingJobStatus: any = false;

    maxWaitNetworkError: any = 30000; // default wait, will read from refresh interval on initialization

    lang: any;
    jobs = [];
    priorityQueues = [];
    allJobs = [];
    currentUserRole = {};
    snapshots = {};
    selectedJobs = {}; // for the run-status dialog
    runJobExecution = {}; // execution data for the run-status dialog
    runJobDialogData = {}; // dialog data for the run-status dialog
    dialogService: any;

    serviceHost = {};
    serviceHosts = [];
    gridHelper: any;
    queueGridHelper: any;
    isAdmin: boolean;
    isShowCompletedJobs: boolean;
    loaded: boolean = false;
    isAllowedToReprioritise = false;

    defaultNoOfSplits: any;
    //For the unused methods
    chartSettingsDisk: any;
    chartSettingsMemory: any;
    chartSettingsTotalMemory: any;
    chartSettingsCpu: any;
    chartSettingsNetwork: any;
    //

    hasError: boolean;
    lastReceived: any;
    statusMessage: string;
    editJobModel: {
        job: any;
        maxRolePriority: any;
        display: string;
        isEdit: any;
        isAdd: boolean;
        isCopy: boolean;
        cancel: any;
        allJobs: any;
        title: string;
        saveBtnText: string;
    };
    maxRolePriority: any;

    constructor(
        private $rootScope,
        private platformSettingsService,
        private gridSettingsService,
        private jobsService,
        private gridHelperServiceFactory,
        private modalDialogService,
        private $timeout,
        private activityMonitorService,
        private $interval,
        private serverEventsService,
        private usersService,
        private currentUserService,
        private $scope,
        private omcDialogService,
        private language,
        private uiActionsService,
        private dataService,
        private matDialogService: MatDialogService
    ) {
        this.lang = language;
        this.dialogService = omcDialogService;
    }

    $onInit() {
        this.initialiseGrid();
        this.initialise();
        this.initialiseCharts();
        this.initialiseConnectivityCheck();
        this.initializePriorityQueueGrid();

        this.$scope.stopJobCheck = () => {
            if (angular.isDefined(this.jobCheck)) {
                console.log('jobsController: cancelling interval...');
                this.$interval.cancel(this.jobCheck);
                this.jobCheck = undefined;
                this.isRefreshingJobStatus = false;
            }
        };

        (<any>window).omc.currentVm = this;
        (<any>window).omc.currentVm.refresh = () => this.getJobs(true);

        this.getJobs(true);
        this.getPriorityQueue();
        this.isShowCompletedJobs = false;
        this.usersService.getUsers(true).then((users) => {
            var user = users.find((f) => f.id === this.currentUserService.user.id);
            var omcAdmin = user.roles.filter((f) => f.application === 'OMC' && f.roleName === 'Administrator');
            this.isAdmin = omcAdmin.length > 0;
        });
    }

    $onDestroy() {
        this.stopJobCheck();
    }

    initialise() {
        this.serverEventsService.initialise();
        $(window).on('resize', this.activityPageHeight.bind(this));
        this.$timeout(this.activityPageHeight.bind(this));

        this.platformSettingsService.getSettings().then((settings) => {
            this.serviceHosts = [
                { name: settings.jobServiceUrl, description: settings.jobServiceUrl + ' [Primary]' },
                {
                    name: settings.jobServiceUrlSecondary,
                    description: settings.jobServiceUrlSecondary + ' [Secondary]',
                },
            ];
            this.serviceHost = this.serviceHosts[0];
            this.jobStatusUpdatePeriodSeconds = settings.jobStatusUpdatePeriodSeconds;
            this.defaultNoOfSplits = settings.defaultNoOfSplits;
            this.activityPageHeight();
        });
        this.getUserSettings();

        this.$rootScope.$on('runJobStarted', (event, ids) => this.setInitialJobDetailsOnRun(ids));
        this.$rootScope.$on('serverEvent:JobsServerEvent', (event, id) => this.jobsServerEvent(event, id));
        //$rootScope.$on("activityMonitorServiceUpdate:CpuLoad", updateGridCpu);
        //$rootScope.$on("activityMonitorServiceUpdate:AvailableMemory", updateAvailableMemory);
        //$rootScope.$on("activityMonitorServiceUpdate:DiskLoad", updateDiskLoad);
        //$rootScope.$on("activityMonitorServiceUpdate:TotalMemory", updateGridTotalMemory);
        //$rootScope.$on("activityMonitorServiceUpdate:NetworkThroughput", updateNetworkThroughput);
        this.$rootScope.$on('userSettingsUpdated', (event, id) => {
            this.getUserSettings();
        });
    }

    initialiseGrid() {
        this.gridHelper = this.gridHelperServiceFactory.gridHelper(
            'activityMonitorController',
            'activity-grid',
            this,
            this.columnDefs()
        );
        this.gridHelper.gridData.gridId = 'activity-monitor-grid';
        this.gridSettingsService.initialiseGridSettings({
            id: this.gridHelper.gridData.gridId,
            name: 'Activity-Grid',
            columnsInfo: [],
        });

        this.uiActionsService.getPermissionsForName('activity-monitor-reprioritise').then((perm) => {
            this.isAllowedToReprioritise = perm && !perm.disabled;
        });

        this.gridSettingsService.setParentHeight($('#content-activity-monitor'), $('#activity-grid'));
        this.gridRowSelected = this.gridHelper.gridRowSelected;
    }

    initializePriorityQueueGrid() {
        this.queueGridHelper = this.gridHelperServiceFactory.gridHelper(
            'queuePriorityController',
            'queuePriority-grid',
            this,
            this.queueColumnDefs()
        );
        this.queueGridHelper.gridData.gridId = 'queue-priority-grid';
        this.gridSettingsService.initialiseGridSettings({
            id: this.queueGridHelper.gridData.gridId,
            name: 'QueuePriority-Grid',
            columnsInfo: [],
        });

        this.gridSettingsService.setParentHeight($('#content-activity-monitor'), $('#queuePriority-grid'));
        this.queueGridRowSelected = this.queueGridHelper.queueGridRowSelected;
    }

    gridRowSelected(item) {
        return this.gridHelper.selectedValues().find((x) => x === item);
    }

    queueGridRowSelected(item) {
        return this.queueGridHelper.selectedValues().find((x) => x === item);
    }

    cancelAllJobs() {
        this.confirmCancelJobs(this.jobs, 'Are you sure you want to cancel all running jobs?', false, false);
    }


    cancelAllQueuedJobs() {
        this.confirmCancelJobs(this.priorityQueues, 'Are you sure you want to cancel all queued/scheduled jobs?', true, true);
    }

    stopJobCheck() {
        if (angular.isDefined(this.jobCheck)) {
            console.log('jobsController: cancelling interval...');
            this.$interval.cancel(this.jobCheck);
            this.jobCheck = undefined;
            this.isRefreshingJobStatus = false;
        }
    }

    getUserSettings() {
        this.currentUserService.getCurrentUser().then((user) => {
            if (user && user.userSettings) {
                this.enableAutoRefresh = user.userSettings.enableAutoRefresh;
            }
        });
    }

    isRefreshDisabled() {
        return !this.enableAutoRefresh && this.loaded;
    }

    /* Bellow are not used [TM 05/05/22] */

    updateAvailableMemory(event, data) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;

        if (this.chartSettingsMemory && this.chartSettingsMemory.data) {
            this.chartSettingsMemory.data.labels = data.labels;
            this.chartSettingsMemory.data.datasets[0].data = data.values;
            this.snapshots['Memory Use'] = data.values[data.values.length - 1] + '%';
            this.$rootScope.$emit('chartDataUpdated', 'chartSettingsMemory');
            this.signalPulse(data);
        }
    }

    updateDiskLoad(event, data) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;

        if (this.chartSettingsDisk && this.chartSettingsDisk.data) {
            this.chartSettingsDisk.data.labels = data.labels;
            this.chartSettingsDisk.data.datasets[0].data = data.values;

            this.snapshots['Disk Use'] = data.values[data.values.length - 1] + '%';
            this.$rootScope.$emit('chartDataUpdated', 'chartSettingsDisk');
            this.signalPulse(data);
        }
    }

    updateGridTotalMemory(event, data) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;

        if (this.chartSettingsTotalMemory && this.chartSettingsTotalMemory.data) {
            this.chartSettingsTotalMemory.data.labels = data.labels;
            this.chartSettingsTotalMemory.data.datasets[0].data = data.values;

            this.snapshots['Total Memory'] = data.values[data.values.length - 1] + 'MB';

            this.$rootScope.$emit('chartDataUpdated', 'chartSettingsTotalMemory');
            this.signalPulse(data);
        }
    }

    updateGridCpu(event, data) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;

        if (this.chartSettingsCpu && this.chartSettingsCpu.data) {
            this.chartSettingsCpu.data.labels = data.labels;
            this.chartSettingsCpu.data.datasets[0].data = data.values;

            this.snapshots['Cpu Utilisation'] = data.values[data.values.length - 1] + '%';

            this.$rootScope.$emit('chartDataUpdated', 'chartSettingsCpu');
            this.signalPulse(data);
        }
    }

    updateNetworkThroughput(event, data) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;

        if (this.chartSettingsNetwork && this.chartSettingsNetwork.data) {
            this.chartSettingsNetwork.data.labels = data.labels;
            this.chartSettingsNetwork.data.datasets[0].data = data.values;

            this.snapshots['Network Throughput'] = data.values[data.values.length - 1] + 'Kbps';

            this.$rootScope.$emit('chartDataUpdated', 'chartSettingsNetwork');
            this.signalPulse(data);
        }
    }

    /* END OF NOT USED FUNCTIONS, SEE PREVIOUS COMMENT FOR START [TM 05/05/22] */

    refreshActivityMonitor() {
        this.activityMonitorService.refreshActivityMonitor();
        this.getJobs(true);
    }

    refreshJobQueue() {
        this.activityMonitorService.refreshJobQueue();
        this.getPriorityQueue();
    }

    signalPulse(data) {
        if (data) {
            if (!this.loaded) {
                this.$timeout(() => this.activityPageHeight.bind(this));
            }
            this.loaded = true;
            this.hasError = false;
            this.lastReceived = new Date().getDate();
        } else {
            this.checkForNetworkError();
        }
    }

    serviceHostChanged(serviceHost) {
        console.log('serviceHostChanged', serviceHost);
    }

    getJobs(force) {
        // Set showSpinner to false on auto-refresh.
        this.jobsService.getAllJobs(force, !this.isShowCompletedJobs).then((jobs) => {
            this.$scope.stopJobCheck();

            jobs.map((job) => job.hasBeenRun && this.jobsService.updateJobFromEmJob(job));

            const runningJobs = jobs.filter((job) => this.jobsService.isRunning(job));

            if (this.isShowCompletedJobs) {
                let completedJobs = jobs.filter((job) => job.hasBeenRun);
                this.jobs = [...new Set([...runningJobs, ...completedJobs])]; // Merge without duplicates
            } else {
                this.jobs = runningJobs;
            }

            // Apply updateJob only to running jobs
            runningJobs.forEach((job) => {
                this.updateJob(job);
            });

            this.gridHelper.dataReloaded(this.jobs);
            this.jobCheck = this.$interval(this.refreshJobStatus.bind(this), this.jobStatusUpdatePeriodSeconds * 1000);
            this.activityPageHeight();
        });
    }

    getPriorityQueue() {
        this.activityMonitorService.getPriorityQueues().then((priorityQueues) => {

            this.priorityQueues = priorityQueues;
            this.queueGridHelper.dataReloaded(this.priorityQueues);
        });
    }

    updateQueuePosition(command) {
        var priorityQueue = this.queueGridHelper.selectedValues()[0];
        this.activityMonitorService.updateQueuePosition(priorityQueue.position, command);
        this.getPriorityQueue();
    }

    refreshJobStatus() {
        if (this.enableAutoRefresh && this.isActivityMonitorVisible() && !this.isRefreshingJobStatus) {
            this.isRefreshingJobStatus = true;
            this.jobsService.refreshJobStatus().then(() => {
                this.isRefreshingJobStatus = false;
            });

            if (this.isShowCompletedJobs)
                this.getJobs(true);

            this.getPriorityQueue();
        }
    }

    isActivityMonitorVisible() {
        return $('#content-activity-monitor').is(':visible');
    }

    jobsServerEvent(event, payload) {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;
        if (payload.forceRefresh) {
            this.getJobs(true);
        } else {
            var jobUpdateDetails = payload.data;
            console.log('jobsServerEvent: payload.data = ', payload.data);
            if (jobUpdateDetails === null || jobUpdateDetails === undefined) return;

            if (Array.isArray(jobUpdateDetails)) {
                var jobIds = jobUpdateDetails.map((x) => x.id.toString()).join(', ');
                console.log('jobsServerEvent: jobIds = ', jobIds);
                this.jobsService.getJobDetailsByIds(jobIds, true, false).then((jobs) => {
                    for (var i = 0; i < jobs.length; i++) {
                        this.updateJob(jobs[i]);
                    }
                    if (!this.isShowCompletedJobs) {
                        this.jobs = this.jobs.filter((x) => this.jobsService.isRunning(x));
                    }
                    this.gridHelper.dataReloaded(this.jobs);
                });
            } else {
                console.log('jobsServerEvent: jobUpdateDetails.id = ', jobUpdateDetails.id);
                this.jobsService.getJobDetailsById(jobUpdateDetails.id, true, false).then((job) => {
                    this.updateJob(job);

                    if (!this.isShowCompletedJobs) {
                        this.jobs = this.jobs.filter((x) => this.jobsService.isRunning(x));
                    }
                    this.gridHelper.dataReloaded(this.jobs);
                });
            }
        }
    }

    reRunjobEvent(event, payload) {
        if (!this.jobs || !this.isActivityMonitorVisible() || !payload || !payload.data || !Array.isArray(payload.data))
            return;
        payload.data.forEach((jobUpdate) => {
            let job = this.jobs.find((job) => job.id === jobUpdate.id);
            if (job) {
                job.lastJobExecuted = jobUpdate.lastJobExecuted || {};
                job.lastRunEnd = job.lastJobExecuted.endTime = jobUpdate.lastRunEnd;
                job.jobDonePercent = job.lastJobExecuted.jobDonePercent = zeroToHundred(jobUpdate.jobDonePercent);
                job.state = jobUpdate.state;
                job.lastRunStart = jobUpdate.lastRunStart;
                job.lastRunByName = jobUpdate.lastRunByName;
                job.hasBeenRun = jobUpdate.hasBeenRun;
                job.hasResults = jobUpdate.hasResults;
                job.reportUrl = jobUpdate.reportUrl;
            } else {
                console.warn(`reRunjobEvent: Received job id ${jobUpdate.id} but could not find job to update`);
            }
        });
        function zeroToHundred(n) {
            if (typeof n === 'number') {
                return n > 100 ? 100 : n < 0 ? 0 : OmcFunc.limitDecimals(n, 0);
            } else {
                return null;
            }
        }
    }

    updateJob(job) {
        var idx = this.jobs.findIndex((x) => x.id === job.id);
        if (idx > -1) {
            this.jobs[idx] = job;
        } else {
            this.jobs.push(job);
        }
        job = this.predictedFinishTime(job);
    }

    predictedFinishTime(job) {
        var jobExecution = job.lastJobExecuted;
        if (jobExecution) {
            var donePercent =
                ((jobExecution.currentTaskNo - 1) / jobExecution.totalTasks) * 100 +
                (100 * job.itemsProcessed) / job.totalItemsToProcess / jobExecution.totalTasks;
            donePercent = Math.min(donePercent, 100);
            job.jobDonePercent = donePercent;
            if (donePercent > 0 && donePercent < 100) {
                var milliseconds: any = Math.abs(
                    new Date(new Date().toUTCString()).getTime() - new Date(job.lastRunStart + 'Z').getTime()
                );
                /* Original legacy for date [TM 12/05/22] */
                // var milliseconds: any = Math.abs(new Date(new Date().toUTCString()) - new Date(job.lastRunStart+'Z'));
                var recordPerMillisecond = job.itemsProcessed / milliseconds;
                var remainingRecords = job.totalItemsToProcess - job.itemsProcessed;
                var estimatedMillisecondsToAdd = remainingRecords / recordPerMillisecond;
                var remainingTasksEstTime =
                    (jobExecution.totalTasks - jobExecution.currentTaskNo) *
                    (job.totalItemsToProcess / recordPerMillisecond);
                estimatedMillisecondsToAdd = estimatedMillisecondsToAdd + remainingTasksEstTime;
                var dateNow = new Date();
                dateNow.setMilliseconds(dateNow.getMilliseconds() + estimatedMillisecondsToAdd);
                job.lastRunEnd = dateNow;
                console.log('job.lastRunEnd = ' + job.lastRunEnd);
            }
        }
        return job;
    }

    initialiseCharts() {
        var cpuData = this.activityMonitorService.getValues('CpuLoad');
        this.chartSettingsCpu = this.yaxisPercentageChartSettings();
        this.chartSettingsMemory = this.yaxisPercentageChartSettings();
        this.chartSettingsDisk = this.yaxisPercentageChartSettings();
        this.chartSettingsNetwork = this.defaultChartSettings();
    }

    initialiseConnectivityCheck() {
        this.loaded = false;
        this.statusMessage = 'Waiting for information...';
        this.lastReceived = new Date().getDate();
        this.$timeout(this.activityPageHeight.bind(this));
        //platformSettingsService.getSettings(true).then(function (setting) {
        //    var interval = setting.runJobsIntervalSeconds || 5;
        //    maxWaitNetworkError = (interval + interval * 0.5)*1000;
        //}).finally(function() {
        //    $interval(checkForNetworkError, maxWaitNetworkError);
        //});

        this.$interval(this.checkForNetworkError.bind(this), this.maxWaitNetworkError); // workaround as service is always returning 5
    }

    checkForNetworkError() {
        if (this.isRefreshDisabled() || !this.isActivityMonitorVisible()) return;
        var currentDate = new Date().getDate();
        if (Math.abs(currentDate - this.lastReceived) > this.maxWaitNetworkError) {
            this.hasError = true;
            var msg = 'Unable to retrieve activity information. Please contact help and support.';
            this.statusMessage = msg;
            console.log(msg);
        } else {
            this.hasError = true;
        }
    }

    activityPageHeight() {
        var $window = $('.logged-in');
        var height = $window.height() + 10;
        //var chartHeight = $('chart-component').height();
        //if (chartHeight === 0) {
        //    chartHeight = height * 0.3; // layout fix in case if charts are not initialized yet.
        //}
        $('.activity-monitor-grid').height((height / 2) - ($('.activity-monitor-grid').offset().top + $('.horizontal').height() + 10));
        $('.queue-priority-grid').height((height / 2) - ($('.queue-priority-grid').offset().top + $('.horizontal').height() + 10));
        
        this.gridHelper?.onRerender();
    }
    
    selectedJob = {};
    editJobDialogData = {};
    
    view(job) {
        let dialogData = new JobsDialogData({
            display: '',
            maxRolePriority: this.maxRolePriority,
            isValid: true,
            cancelBtnText: language.general.OK
        });
        this.jobsService.getJobsWithTasksAndDependencies(job.id).then((job) => {
            this.selectedJob = job;
            this.editJobDialogData = dialogData;
            this.omcDialogService.open('edit-job', { title: 'Job' })
        })
    }

    cancel() {
        this.modalDialogService.hide();
    }

    columnDefs() {
        return [
            {
                name: 'id',
                displayName: '',
                cellTemplate:
                    '<div class="grid-row-vertical-bar" ng-click="grid.appScope.toggleSelected(row.entity, $event); " ng-class="{\'grid-row-selected\': grid.appScope.gridRowSelected(row.entity) }" data-id="{{row.entity.id}}" role="button" tabindex="0"></div>',
                width: this.gridSettingsService.columnWidths.toggleSelect,
                pinnedLeft: true,
                cellClass: 'omc-select-column',
            },
            {
                name: 'description',
                displayName: 'Name',
                headerCellClass: 'description',
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.view(row.entity); $event.preventDefault();">{{row.entity.description}}</a></div>',
                width: 350,
            },
            {
                name: 'jobTasks',
                displayName: 'Tasks',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'lastRunStart',
                displayName: 'Last Run Started',
                headerCellClass: 'lastRunStart',
                cellFilter: 'omcDate',
                width: this.gridSettingsService.columnWidths.dateTime,
            },
            {
                name: 'lastRunEnd',
                displayName: 'Last Run Ended',
                headerCellClass: 'lastRunEnd',
                cellTemplate: `<span class="ui-grid-cell-contents" ng-class="{'text-italic': row.entity.jobDonePercent > 0 && row.entity.jobDonePercent < 100 && row.entity.state === 'Running'}">{{row.entity.lastRunEnd | omcDate }}</span>`,
                cellFilter: 'omcDate',
                width: this.gridSettingsService.columnWidths.dateTime,
            },
            {
                name: 'lastRunByName',
                displayName: 'Last Run By',
                headerCellClass: 'Created-By-Name',
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.showUserProfile(row.entity.lastRunById); $event.preventDefault();">{{row.entity.lastRunByName}}</a></div>',
                width: this.gridSettingsService.columnWidths.userName,
            },
            {
                name: 'state',
                displayName: 'State',
                headerCellClass: 'status',
                width: 165,
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.showExecutionHistoryDialog(row.entity); $event.preventDefault();">{{row.entity.state}}</a></div>',
            },
            {
                name: 'downloadResults',
                displayName: 'Results',
                width: 165,
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a check-permissions="result-export" href="#" ng-click="grid.appScope.downloadResults(row.entity); $event.preventDefault();" ng-show="grid.appScope.canDownloadResults(row.entity)">Download</a></div>',
            },
            {
                name: 'progress',
                displayName: 'Progress',
                headerCellClass: 'job-progress',
                cellTemplate: '<job-progress-component [job]="row.entity" ></job-progress-component>',
                width: 200,
            },
            {
                name: 'collectionsName',
                displayName: 'Collections',
                headerCellClass: 'CompiledTask',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'notes',
                displayName: 'Notes',
                width: this.gridSettingsService.columnWidths.notes,
            },
            {
                name: 'dateCreated',
                displayName: 'Date Created',
                headerCellClass: 'DateCreated',
                cellFilter: 'omcDate',
                width: this.gridSettingsService.columnWidths.dateTime,
            },
            {
                name: 'createdByName',
                displayName: 'Created By',
                headerCellClass: 'Created-By-Name',
                width: this.gridSettingsService.columnWidths.userName,
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.showUserProfile(row.entity.createdById); $event.preventDefault();">{{row.entity.createdByName}}</a></div>',
            },
        ];
    }

    queueColumnDefs() {
        return [
            {
                name: 'id',
                displayName: '',
                cellTemplate:
                    '<div class="grid-row-vertical-bar" ng-click="grid.appScope.toggleSelected(row.entity, $event); " ng-class="{\'grid-row-selected\': grid.appScope.queueGridRowSelected(row.entity) }" data-id="{{row.entity.id}}" role="button" tabindex="0"></div>',
                width: this.gridSettingsService.columnWidths.toggleSelect,
                pinnedLeft: true,
                cellClass: 'omc-select-column',
            },
            {
                name: 'position',
                displayName: 'Queue Position',
                headerCellClass: 'position',
                cellTemplate:
                    '<div class="ui-grid-cell-contents"><a href="#"  $event.preventDefault();">{{row.entity.position}}</a></div>',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'name',
                displayName: 'Name',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'linkedTasks',
                displayName: 'Tasks',
                headerCellClass: 'linkedTasks',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'scheduledStart',
                displayName: 'Scheduled To Start',
                headerCellClass: 'lastRunEnd',
                cellFilter: 'omcDate',
              /*  cellTemplate: `<span class="ui-grid-cell-contents" ng-class="{'text-italic': row.entity.jobDonePercent > 0 && row.entity.jobDonePercent < 100 && row.entity.state === 'Running'}">{{row.entity.lastRunEnd | omcDate }}</span>`,*/
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'runBy',
                displayName: 'Run By',
                headerCellClass: 'Created-By-Name',
                //cellTemplate:
                //    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.showUserProfile(row.entity.lastRunById); $event.preventDefault();">{{row.entity.lastRunByName}}</a></div>',
                width: this.gridSettingsService.columnWidths.default,
            },
            {
                name: 'state',
                displayName: 'State',
                headerCellClass: 'status',
                width: 165,
                //cellTemplate:
                //    '<div class="ui-grid-cell-contents"><a href="#" ng-click="grid.appScope.showExecutionHistoryDialog(row.entity); $event.preventDefault();">{{row.entity.state}}</a></div>',
            },
            {
                name: 'collectionName',
                displayName: 'Collections',
                headerCellClass: 'CompiledTask',
                width: this.gridSettingsService.columnWidths.default,
            },           
        ];
    }

    defaultChartSettings() {
        return {
            type: 'line',
            data: {
                //labels: cpuData && cpuData.labels,
                datasets: [
                    {
                        label: '',
                        //data: cpuData && cpuData.values,
                        backgroundColor: [
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                        ],
                        borderColor: [
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                        ],
                        borderWidth: 1,
                        pointBorderColor: 'transparent',
                        pointHoverBorderColor: 'transparent',
                        pointBackgroundColor: 'transparent',
                        pointHoverBackgroundColor: 'transparent',
                    },
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 20,
                    },
                },
                legend: {
                    display: false,
                },
                maintainAspectRatio: false,
                elements: {
                    line: {
                        tension: 0, // disables bezier curves
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                beginAtZero: true,
                            },
                            gridLines: {
                                color: 'rgba(17, 149, 198, 0.2)',
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                color: 'rgba(17, 149, 198, 0.2)',
                            },
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0,
                                minRotation: 0,
                            },
                        },
                    ],
                },
                tooltips: {
                    enabled: false,
                },
                animation: false,
            },
        };
    }

    yaxisPercentageChartSettings() {
        return {
            type: 'line',
            data: {
                //labels: cpuData && cpuData.labels,
                datasets: [
                    {
                        label: '',
                        //data: cpuData && cpuData.values,
                        backgroundColor: [
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                            'rgba(17, 149, 198, 0.2)',
                        ],
                        borderColor: [
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                            'rgba(17, 149, 198, 1)',
                        ],
                        borderWidth: 1,
                        pointBorderColor: 'transparent',
                        pointHoverBorderColor: 'transparent',
                        pointBackgroundColor: 'transparent',
                        pointHoverBackgroundColor: 'transparent',
                    },
                ],
            },
            options: {
                layout: {
                    padding: {
                        top: 20,
                    },
                },
                legend: {
                    display: false,
                },
                maintainAspectRatio: false,
                elements: {
                    line: {
                        tension: 0, // disables bezier curves
                    },
                },
                scales: {
                    yAxes: [
                        {
                            ticks: {
                                callback: (label, index, labels) => {
                                    return label + '%';
                                },
                                beginAtZero: true,
                                max: 100,
                                stepSize: 20,
                            },
                            gridLines: {
                                color: 'rgba(17, 149, 198, 0.2)',
                            },
                        },
                    ],
                    xAxes: [
                        {
                            gridLines: {
                                color: 'rgba(17, 149, 198, 0.2)',
                            },
                            ticks: {
                                autoSkip: false,
                                maxRotation: 0,
                                minRotation: 0,
                            },
                        },
                    ],
                },
                tooltips: {
                    enabled: false,
                },
                animation: false,
            },
        };
    }
    canRerunJob() {
        let selectedJobs = this.gridHelper.selectedValues();
        return (
            selectedJobs.length == 1 && !this.jobsService.isRunning(selectedJobs[0])
        );
    }

    reRunSelectedJob() {
        this.runJobDialogData = {
            display: '',
            isEdit: true,
            maxRolePriority: this.maxRolePriority,
        };
        //get jobs
        const job = this.gridHelper.selectedValues()[0];
        //get tasks for jobs
        let url = 'getLastExecutionHistory?jobId=' + job.id;
        return Promise.all([this.dataService.getData(url, url, true), this.getHistoricalJobTasks(job.id)]).then(
            ([jobHistoryData, historyTasks]) => {

                this.runJobDialogData = {
                    display: '',
                    canDownload: false,
                    isEdit: true,
                    reRun: true,
                    lastJobExecutedId: historyTasks.executionHistoryId,
                    maxRolePriority: this.maxRolePriority
                };
                job.tasks = historyTasks.tasks;
                // cherry pick the required attributes from jobHistoryData
                this.runJobExecution = OmcFunc.diluteObject(jobHistoryData, [
                    'emServiceJobId',
                    'scheduledStartDate',
                    'logLevel',
                    'writeLimit',
                    'abortLimit',
                    'deferExecution',
                    'honourJobDependency',
                    'maxExecutionTimeMins',
                    'noOfParallelThreads',
                    'noOfSplits',
                    'noOfWorkers',
                    'failOnWarning',
                    'verifyDatasetChecksum',
                    'jobPriority',
                    'isExpireJobAfter',
                    'expireJobAfterDays',
                    'expireJobAfterHours',
                    'expireJobAfterMins',
                    'failJobOnTaskFail',
                    'runJobUntilCancelExpired',
                    'holdJobUntilDate',
                    'alertOnJobFailure',
                    'alertOnJobCommencement',
                    'alertOnJobCompletion',
                    'jobRunSubscribers',
                    'distributionStrategyId',
                    'aggregateWorkerOutput',
                    'workerConfigurationName',
                ]);
                this.selectedJobs = [job];
                let title = 'Rerun Job';
                this.runJobDialogData;
                this.omcDialogService.open('run-job', { title: title });
            }
        );
    }

    closeDialog(id) {
        this.omcDialogService.close(id);
    }

    setInitialJobDetailsOnRun(jobIds = []) {
        console.log(`Run job started, updating jobs prior to server event`, jobIds);
        let initialPayload = { data: [] };
        jobIds.forEach((jobId) => {
            initialPayload.data.push({
                id: jobId,
                lastRunStart: '',
                lastRunByName: this.currentUserService.user.id,
                hasBeenRun: true,
                hasResults: false,
                reportUrl: '',
                state: 'Submitted',
                jobDonePercent: null,
                lastRunEnd: '',
                lastJobExecuted: null,
            });
        });
        // If a job is rerun from the active jobs grid, it will be moved to the queue for the next execution, and it must be removed from the completed jobs list.
        this.jobs = this.jobs.filter(existingJob => existingJob.id !== jobIds[0]);
        this.gridHelper.dataReloaded(this.jobs);
        this.reRunjobEvent(null, initialPayload);
    }

    canCancelJobs() {
        return (
            this.gridHelper.selectedValues().length &&
            this.gridHelper.selectedValues().every((x) => this.jobsService.isRunningOnly(x))
        );
    }

    canCancelQueuedJobs() {
        return (
            this.queueGridHelper.selectedValues().length
        );
    }

    runImmediatelyQueuedJob() {
        var runNextJob = this.queueGridHelper.selectedValues()[0];
        if (runNextJob.isDeferExecution) {
            let dateLocalCulture = moment.utc(runNextJob.scheduledStart).local().format('DD/MM/YYYY HH:mm:ss');
            this.confirmRunNextScheduledJob(runNextJob,
                '' + runNextJob.name + ' is currently scheduled to run at: ' + dateLocalCulture + '.' + `\n` + 'Please confirm you wish to change this to run it next.')
        }
        else {
            this.jobsService.runImmediatelyQueuedJob(runNextJob);
        }
        this.getPriorityQueue();
    }

    cancelSelectedQueuedJobs() {
        this.confirmCancelJobs(this.queueGridHelper.selectedValues(),
            'Are you sure you want to cancel the selected job(s)?', true, false
        );
    }

    moveUpDisable() {
        // check permission.
        if (!this.isAllowedToReprioritise) {
            return true;
        }

        // Check if the queued jobs exceed one in the grid.
        const queuedJobsCount = this.queueGridHelper.gridData.data.filter(x => x.state === 'Queued').length;
        if (queuedJobsCount === 1)
            return true;

        if (this.queueGridHelper.selectedValues().length !== 1)
            return true;

        //if job scheduled.
        const selectedValue = this.queueGridHelper.selectedValues()[0];
        if (selectedValue.isDeferExecution)
            return true;

        if (selectedValue.position === 1)
            return true;

        return false;
    }

    runNextDisable() {
        // Check permission
        if (!this.isAllowedToReprioritise) {
            return true;
        }

        const selectedValues = this.queueGridHelper.selectedValues();
        const selectedCount = selectedValues.length;

        // Ensure only one job is selected
        if (selectedCount !== 1) {
            return true;
        }

        const selectedValue = selectedValues[0];

        // If the job is queued and there's only one selected
        if (selectedValue.state === 'Queued') {
            const queuedJobsCount = this.queueGridHelper.gridData.data.filter(x => x.state === 'Queued').length;

            // If there is only one queued job
            if (queuedJobsCount === 1) {
                return true;
            }

            // Check if any queued job has a lower position than the selected job
            const hasLowerPosition = this.queueGridHelper.gridData.data.some(
                x => x.state === 'Queued' && x.position < selectedValue.position
            );

            if (hasLowerPosition) {
                return false;
            }
        }

        return !selectedValue.isDeferExecution;
    }

    moveDownDisable() {
        // Check permission
        if (!this.isAllowedToReprioritise) {
            return true;
        }

        // Check if there is only one queued job in the grid
        const queuedJobsCount = this.queueGridHelper.gridData.data.filter(x => x.state === 'Queued').length;
        if (queuedJobsCount === 1) {
            return true;
        }

        // Check if only one job is selected
        const selectedValues = this.queueGridHelper.selectedValues();
        if (selectedValues !== null && selectedValues.length !== 1) {
            return true;
        }

        // Get the selected job
        const selectedValue = selectedValues[0];

        // Check if the job is deferred
        if (selectedValue.isDeferExecution) {
            return true;
        }

        // Check if any queued job has a higher position than the selected job
        const hasHigherPosition = this.queueGridHelper.gridData.data.some(
            x => x.state === 'Queued' && x.position > selectedValue.position
        );

        return !hasHigherPosition;
    }

    cancelSelectedJobs() {
        this.confirmCancelJobs(
            this.gridHelper.selectedValues(),
            'Are you sure you want to cancel the selected job(s)?', false, false
        );
    }

    confirmCancelJobs(jobs, prompt, cancelQueued, cancelAllJobs) {
        this.matDialogService.openConfirmDialog(prompt).subscribe((confirmed: boolean) => {
            if (confirmed) {
                // cancel queued/scheduled job.
                if (cancelQueued) {
                    this.jobsService.cancelQueuedJobs(jobs, cancelAllJobs);
                    this.getPriorityQueue();
                }
                else {
                    this.jobsService.cancelJobs(jobs);
                    this.getJobs(false);
                }
            }
        });
    }

    confirmRunNextScheduledJob(job, prompt) {
        this.matDialogService.openConfirmDialog(prompt).subscribe((confirmed: boolean) => {
            if (confirmed) {
                this.jobsService.runImmediatelyQueuedJob(job);
            }
        });
    }

    showExecutionHistoryDialog(job) {
        let url = 'getLastExecutionHistory?jobId=' + job.id;
        Promise.all([this.dataService.getData(url, url, true), this.getHistoricalJobTasks(job.id)]).then(
            ([jobHistoryData, historyTasks]) => {
                let startTime = jobHistoryData.startTime
                    ? moment.utc(jobHistoryData.startTime).local().format('DD/MM/YYYY HH:mm:ss')
                    : '';
                let endTime = jobHistoryData.endTime
                    ? moment.utc(jobHistoryData.endTime).local().format('DD/MM/YYYY HH:mm:ss')
                    : '';
                this.runJobDialogData = {
                    display: 'logs',
                    canDownload: false,
                    isEdit: false,
                    maxRolePriority: this.maxRolePriority,
                    anySelectedJobsRunning: false,
                    lastJobExeId: jobHistoryData.id,
                };
                job.tasks = historyTasks.tasks;
                this.selectedJobs = [job];
                // cherry pick the required attributes from jobHistoryData
                this.runJobExecution = OmcFunc.diluteObject(jobHistoryData, [
                    'emServiceJobId',
                    'scheduledStartDate',
                    'logLevel',
                    'writeLimit',
                    'abortLimit',
                    'deferExecution',
                    'honourJobDependency',
                    'maxExecutionTimeMins',
                    'noOfParallelThreads',
                    'noOfSplits',
                    'noOfWorkers',
                    'failOnWarning',
                    'verifyDatasetChecksum',
                    'jobPriority',
                    'isExpireJobAfter',
                    'expireJobAfterDays',
                    'expireJobAfterHours',
                    'expireJobAfterMins',
                    'expireJobAfterSecs',
                    'failJobOnTaskFail',
                    'runJobUntilCancelExpired',
                    'holdJobUntilDate',
                    'alertOnJobFailure',
                    'alertOnJobCommencement',
                    'alertOnJobCompletion',
                    'jobRunSubscribers',
                    'distributionStrategyId',
                    'aggregateWorkerOutput',
                    'workerConfigurationName',
                ]);
                Object.assign(this.runJobExecution, {
                    jobExStartTime: startTime,
                    jobExEndTime: endTime,
                    jobExState: jobHistoryData.state,
                    jobExStartedBy: jobHistoryData.userId,
                    jobExTaskRecords: JobHistoryTaskRecords.makeFromJobTaskHistory(historyTasks),
                });
                let title = 'Job Run';
                this.omcDialogService.open('run-job', { title: title });
            }
        );
    }

    /**
     * @param {string} id
     * @returns {JobTaskHistory}
     */
    getHistoricalJobTasks(jobId) {
        let endPoint = 'getLastTasksExecutionHistory?jobId=' + jobId;
        return this.dataService
            .getData(endPoint, endPoint, true)
            .then((data) => {
                if (!!data) {
                    let historyData = new JobTaskHistory(data);
                    console.log(historyData);
                    return historyData;
                } else {
                    return {};
                }
            })
            .catch((err) => {
                throw err;
            });
    }
}

const ActivityMonitorComponent: OmcComponent = {
    selector: `activityMonitorComponent`,
    template: require('./activity-monitor.component.html'),
    bindings: {},
    controller: ActivityMonitorController,
};

angular.module('omc').component(ActivityMonitorComponent.selector, ActivityMonitorComponent);
